import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-exclamation-triangle-icon',
  imports: [],
  templateUrl: './exclamation-triangle-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './exclamation-triangle-icon.component.scss',
})
export class ExclamationTriangleIconComponent {}
